import DateSelectBox from '@/pages/policy/components/DateSelectBox';
import { termsSelectItem } from '@/pages/policy/constants';
import { useState } from 'react';
import Terms250410 from '@/pages/policy/terms/Terms250410';
import Terms250623 from '@/pages/policy/terms/Terms250623';

const Terms = () => {
	const [selectedDate, setSelectedDate] = useState<string>(termsSelectItem[0]?.text || ''); // 선택된 시행 일자

	return (
		<>
			<DateSelectBox selectItems={termsSelectItem} selectedDate={selectedDate} setSelectedDate={setSelectedDate} />
			{selectedDate === termsSelectItem[0].text && <Terms250623 />}
			{selectedDate === termsSelectItem[1].text && <Terms250410 />}
		</>
	);
};

export default Terms;
